





































import Vue from 'vue';
import OptionBase from './OptionBase.vue';
import VueSelectImage from 'vue-select-image';
import 'vue-select-image/dist/vue-select-image.css';
import ImageChoiceOption from '@/models/options/ImageChoiceOption';

export default Vue.extend({
  extends: OptionBase,
  components: {
    VueSelectImage,
  },
  computed: {
    dataImages() {
      return ((this as any).optionData as ImageChoiceOption).choices.map( (image) => {
        return {
          id: image.alias,
          src: image.path,
        };
      });
    },
    selectedImages() {
      return [
        {
          id: ((this as any).optionData as ImageChoiceOption).defaultValue,
        },
      ];
    },
  },
  methods: {
    onSelectImage(s: any) {
      (this as any).currentValue = s.id;
    },
  },
});
